import { AccessModeEnum } from '@zaoblako/shared/modules/pacs/enums/access-mode.enum';
import { RoomFindDto, type RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';

import * as yup from 'yup';

/** Room access settings for user or group (response body) */
export interface RoomAccessFindInterface {
  /** Is user or group totally blocked */
  blocked?: boolean;
  /** Access mode for user/group */
  accessMode?: AccessModeEnum;
  /**
   * Has user or group access to all rooms. This flag has sense only when
   * {@link RoomAccessFindInterface.accessMode} equals {@link AccessModeEnum.EVERYWHERE}.
   */
  hasAccess?: boolean;
  /**
   * A list of rooms that the user or group has access to. This list has sense only when
   * {@link RoomAccessFindInterface.accessMode} equals {@link AccessModeEnum.BY_ROOMS}.
   */
  rooms?: RoomFindInterface[];
}

/** Room access settings for user or group (response body) - DTO schema */
export const RoomAccessFindDto = SerdeDtoClass.create<RoomAccessFindInterface>(SecurityDtoKeysEnum.ROOM_ACCESS_FIND_DTO, {
  blocked: {
    optional: true,
    label: 'Заблокирован',
    hint: 'Польностью закрывает доступ к СКУД, не затрагивая остальные настройки',
    serializer: yup.boolean(),
  },
  accessMode: {
    label: 'Режим доступа',
    serializer: yup
      .string()
      .oneOf(Object.values(AccessModeEnum)),
  },
  hasAccess: {
    optional: true,
    label: 'Доступ везде разрешен',
    serializer: yup.boolean(),
  },
  rooms: {
    optional: true,
    label: 'Доступные помещения',
    nested: RoomFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
});
